<template>
  <div
    class="search-list-pagination"
  >
    <template v-if="!showPagination && (isSeoPage || isSeaPage) && pages > 1">
      <button
        class="btn btn-primary btn-block moreObjects"
        type="button"
        @click="showSearchPage"
      >
        {{ $t('common:moreObjects') }}
      </button>
    </template>
    <template v-else-if="pages > 1">
      <pagination-nav
        :pages="pages"
        :current="page"
        class="float-right"
        @setPage="setNewPage"
      />
    </template>
  </div>
</template>

<script>
import { getOtherQueryParams } from 'utils/SearchFilterHelper';
import searchRedirect from 'mixins/composition/search/SearchFunctions';
import StateProviderSetup from 'mixins/composition/search/StateProvider';
import { getReducedCtx } from 'mixins/composition/search/index';

import PaginationNav from 'components/PaginationNav.vue';

export default {
  name: 'SearchListPagination',
  components: {
    PaginationNav,
  },
  setup(props, ctx) {
    const {
      isSeoPage, isSeaPage, totalObjects, totalObjectsCollapse,
    } = StateProviderSetup(getReducedCtx(ctx));
    return {
      isSeoPage, isSeaPage, searchRedirect, totalObjects, totalObjectsCollapse,
    };
  },
  computed: {
    showPagination() {
      return !this.isSeoPage && !this.isSeaPage;
    },
    pages() {
      const maxElasticSearchReturn = 10000;
      if (this.totalObjectsCollapse > 0) {
        return Math.min(Math.ceil(this.totalObjectsCollapse / this.objectsPerPage), (maxElasticSearchReturn / this.objectsPerPage));
      }
      return Math.min(Math.ceil(this.totalObjects / this.objectsPerPage), (maxElasticSearchReturn / this.objectsPerPage));
      // return Math.min(Math.ceil(this.totalObjects / this.objectsPerPage), 10);
    },
    objectsPerPage: {
      get() {
        return this.$store.state.searchFilter.objectsPerPage;
      },
      set(newValue) {
        this.$store.commit('SET_SEARCHFILTER', { objectsPerPage: newValue });
      },
    },
    page: {
      get() {
        return this.$store.getters.getSearchFilter('page') || 1;
      },
      set(newPage) {
        searchRedirect({ router: this.$router, filters: { page: newPage } });
      },
    },
  },
  methods: {
    showSearchPage() {
      this.$store.commit('SET_ISSEOPAGE', false);
      this.$store.commit('SET_ISSEAPAGE', false);
      this.$router.push({
        name: 'Search',
        hash: '#paginationSentinel',
        query: {
          ...this.$store.getters.getMergedTerms,
          // filter partner to reset sea
          ...Object.keys(getOtherQueryParams(this.$router.currentRoute.query)).filter((el) => el.toLowerCase() !== 'pid' && el !== 'partner').reduce((aggr, current) => {
            aggr[current] = getOtherQueryParams(this.$router.currentRoute.query)[current];
            return aggr;
          }, {}),
          objectsPerPage: process.env.OBJECTS_PER_PAGE || 40,
        },
      });
    },
    setNewPage(newpage) {
      this.page = newpage;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-list-pagination {
  overflow: hidden;
  margin: 0 $margin_content 2*$margin_content;
}
</style>
